class PriceRangeSlider {
    constructor() {
        this.leftSliderPointEl = document.getElementById('left-slider');
        this.rightSliderPointEl = document.getElementById('right-slider');

        this.minPriceInput = document.getElementById('range-min-price');
        this.maxPriceInput = document.getElementById('range-max-price');

        this.minPriceText = document.getElementById('min-price-text');
        this.maxPriceText = document.getElementById('max-price-text');

        this.line = document.getElementById('line-slider');
        this.lineActive = document.getElementById('line-active-slider');

        this.minPrice = 0;
        this.maxPrice = 100;

        this.rangeChanging = false;
    }

    init() {
        if (
            !this.leftSliderPointEl ||
            !this.rightSliderPointEl ||
            !this.minPriceInput ||
            !this.maxPriceInput ||
            !this.line
        ) return;


        this.minPrice = parseInt(this.minPriceInput.value);
        this.maxPrice = parseInt(this.maxPriceInput.value);

        this.initChangeListeners();

        this.updatePrices();
    }

    render() {
        this.applyPositionChanges()

        this.minPriceText.innerText = this.minPriceInput.value;
        this.maxPriceText.innerText = this.maxPriceInput.value;
    }

    applyPositionChanges() {
        this.leftSliderPointEl.style.left = `${this.leftPosition}%`;
        this.rightSliderPointEl.style.left = `${this.rigthPosition}%`;

        const left = Math.min(this.rigthPosition, this.leftPosition);
        this.lineActive.style.left = `${left}%`;
        const width = Math.max(this.rigthPosition, this.leftPosition);
        this.lineActive.style.width = `${width - left}%`;
    }

    moveSliderPointsForCurrentPrice() {
        this.moveLeftSliderPoint(this.minPriceInput.value);
        this.moveRightSliderPoint(this.maxPriceInput.value);
    }

    resetRange() {
        this.moveLeftSliderPoint(this.minPrice)
        this.moveRightSliderPoint(this.maxPrice)
    }

    calcPointPosition(price) {
        return ((price - this.minPrice) * 100 / (this.maxPrice - this.minPrice));
    }

    moveLeftSliderPoint(price) {
        this.leftPosition = this.calcPointPosition(price);
    }

    moveRightSliderPoint(price) {
        this.rigthPosition = this.calcPointPosition(price);
    }

    updatePrices() {
        this.minPrice = Math.min(this.minPriceInput.value, this.minPriceInput.min);
        this.maxPrice = Math.max(this.maxPriceInput.value, this.maxPriceInput.max);

        this.moveSliderPointsForCurrentPrice();
        this.render();
    }

    changeLeftPoint(event) {
        const pageX = event.pageX || event.touches[0].pageX;
        const cursorPosition = pageX - this.line.getBoundingClientRect().left;
        const rightPoint = this.rightSliderPointEl.getBoundingClientRect().left - this.line.getBoundingClientRect().left;

        const leftBorder = 0;
        const rightBorder = this.line.offsetWidth;

        if (leftBorder <= cursorPosition && cursorPosition <= rightBorder) {
            const price = this.minPrice + (this.maxPrice - this.minPrice) * cursorPosition / rightBorder;

            this.moveLeftSliderPoint(price);

            if (cursorPosition >= rightPoint) {
                this.maxPriceInput.value = Math.round(price);
            } else {
                this.minPriceInput.value = Math.round(price);
            }
        } else if (cursorPosition >= rightBorder) {
            this.moveLeftSliderPoint(this.maxPrice)

            this.maxPriceInput.value = this.maxPrice;
        } else if (cursorPosition <= leftBorder) {
            this.moveLeftSliderPoint(this.minPrice)

            this.minPriceInput.value = this.minPrice;
        }
    }

    changeRightPoint(event) {
        const pageX = event.pageX || event.touches[0].pageX;
        const cursorPosition = pageX - this.line.getBoundingClientRect().left;
        const leftPoint = this.leftSliderPointEl.getBoundingClientRect().left - this.line.getBoundingClientRect().left;

        const leftBorder = 0;
        const rightBorder = this.line.offsetWidth;

        if (leftBorder <= cursorPosition && cursorPosition <= rightBorder) {
            const price = this.minPrice + (this.maxPrice - this.minPrice) * cursorPosition / rightBorder;

            this.moveRightSliderPoint(price);

            if (cursorPosition <= leftPoint) {
                this.minPriceInput.value = Math.round(price);
            } else {
                this.maxPriceInput.value = Math.round(price);
            }
        } else if (cursorPosition >= rightBorder) {
            this.moveRightSliderPoint(this.maxPrice)

            this.maxPriceInput.value = this.maxPrice;
        } else if (cursorPosition <= leftBorder) {
            this.moveRightSliderPoint(this.minPrice)

            this.minPriceInput.value = this.minPrice;
        }
    }

    startChanging() {
        this.rangeChanging = true;

        document.body.style.cursor = 'pointer';
        document.body.userSelect = 'none';
    }

    finishChanging() {
        this.minPriceInput.dispatchEvent(new Event('change'));
        this.maxPriceInput.dispatchEvent(new Event('change'));

        document.body.style.cursor = 'default';
        document.body.userSelect = 'auto';

        this.rangeChanging = false;
    }

    initChangeListeners() {
        window.addEventListener('priceChanged', () => this.updatePrices());
        window.addEventListener('resetRange', () => this.resetRange());

        // listen range changes
        const moveLeftSlider = (event) => {
            this.startChanging();
            this.changeLeftPoint(event);
            this.render();
        };
        const moveRightSlider = (event) => {
            this.startChanging();
            this.changeRightPoint(event);
            this.render();
        };

        // start moving points
        // for mouse
        this.leftSliderPointEl.addEventListener('mousedown', () => {
            document.addEventListener('mousemove', moveLeftSlider);
        });

        this.rightSliderPointEl.addEventListener('mousedown', () => {
            document.addEventListener('mousemove', moveRightSlider);
        });

        // for touch
        this.leftSliderPointEl.addEventListener('touchstart', () => {
            document.addEventListener('touchmove', moveLeftSlider, {passive: false});
        }, {passive: false});

        this.rightSliderPointEl.addEventListener('touchstart', () => {
            document.addEventListener('touchmove', moveRightSlider, {passive: false});
        }, {passive: false});

        // finish moving points
        // mouse
        document.addEventListener('mouseup', () => {
            if (!this.rangeChanging) return;

            //  remove listeners
            document.removeEventListener('mousemove', moveLeftSlider);
            document.removeEventListener('mousemove', moveRightSlider);

            this.finishChanging();
            this.render();
        });

        // touch
        document.addEventListener('touchend', () => {
            if (!this.rangeChanging) return;

            document.removeEventListener('touchmove', moveLeftSlider);
            document.removeEventListener('touchmove', moveRightSlider);

            this.finishChanging();
            this.render();
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    (new PriceRangeSlider()).init();
});

